var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVocationalTrainingSkills(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vocational_Training_Skills",
    "data-name": "Vocational Training/Skills",
    transform: "translate(-455 -169)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4265",
    "data-name": "Rectangle 4265",
    width: 93,
    height: 93,
    rx: 10,
    transform: "translate(455 169)",
    fill: "#eef6ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-training-1450387",
    transform: "translate(457.912 169.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9907",
    "data-name": "Path 9907",
    d: "M69.408,31.437H46.584a1.708,1.708,0,0,0-1.7,1.7v9.283L38.323,44.3h-9.2a1.133,1.133,0,0,0-.681.255.083.083,0,0,0-.085.085c-.085.085-.17.085-.17.17l-.085.085c-.085.085-.085.17-.17.17h0l-7.58,11.5a1.766,1.766,0,0,0,.511,2.385,1.717,1.717,0,0,0,.937.255,1.673,1.673,0,0,0,1.448-.766l4.429-6.728v9.453a1.708,1.708,0,0,0,1.7,1.7h9.283a1.708,1.708,0,0,0,1.7-1.7V47.277L44.966,46v5.621a1.708,1.708,0,0,0,1.7,1.7h9.709v1.788L51.524,60.9a1.728,1.728,0,0,0,.17,2.385,1.794,1.794,0,0,0,1.107.426,1.532,1.532,0,0,0,1.277-.6l2.214-2.64v1.277a1.7,1.7,0,1,0,3.407,0V60.478l2.214,2.64a1.645,1.645,0,0,0,1.277.6,1.794,1.794,0,0,0,1.107-.426,1.651,1.651,0,0,0,.17-2.385l-4.854-5.791V53.324h9.794a1.708,1.708,0,0,0,1.7-1.7V33.14A1.708,1.708,0,0,0,69.408,31.437ZM36.79,59.456H30.914V47.7H36.79ZM67.7,49.917H48.287V45.063l4-1.107a1.725,1.725,0,1,0-.937-3.321l-3.066.852V34.843H67.7ZM35.172,42.423a5.961,5.961,0,1,0-5.961-5.961A5.979,5.979,0,0,0,35.172,42.423Zm0-8.431a2.555,2.555,0,1,1-2.555,2.555A2.509,2.509,0,0,1,35.172,33.992Z",
    transform: "translate(-2.193 -1.427)",
    fill: "#2563eb",
    stroke: "#f6fafe",
    strokeWidth: 0.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVocationalTrainingSkills);
export default __webpack_public_path__ + "static/media/Vocational-Training-Skills.d8b20cba76a9d5f718e036281f0f808d.svg";
export { ForwardRef as ReactComponent };